// extracted by mini-css-extract-plugin
module.exports =  {"basic":"basic__Ilf0H","pageContent":"pageContent__tDkgl","formItem":"formItem__7aMDr","directionColumn":"directionColumn__abaTJ","header":"header__sJeu9"};